import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between" }
const _hoisted_3 = { class: "trezo-card-title" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "trezo-card-subtitle mt-[15px] sm:mt-0"
}
const _hoisted_6 = { class: "inline-block relative ltr:pl-[22px] rtl:pr-[22px]" }
const _hoisted_7 = { class: "trezo-card-content" }
const _hoisted_8 = {
  key: 0,
  class: "flex justify-center py-8"
}
const _hoisted_9 = {
  key: 1,
  class: "p-4 bg-red-100 text-red-700 rounded mb-4"
}
const _hoisted_10 = {
  key: 2,
  class: "text-center py-8 text-gray-500"
}
const _hoisted_11 = {
  key: 3,
  class: "table-responsive overflow-x-auto"
}
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = { class: "text-black dark:text-white" }
const _hoisted_14 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_15 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_16 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_17 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_18 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tl-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_19 = { class: "font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] bg-gray-50 dark:bg-[#15203c] whitespace-nowrap ltr:first:rounded-tr-md ltr:last:rounded-tr-md rtl:first:rounded-tr-md rtl:last:rounded-tl-md" }
const _hoisted_20 = { class: "text-black dark:text-white" }
const _hoisted_21 = { class: "text-gray-500 dark:text-gray-400 ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_22 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_23 = { class: "flex items-center" }
const _hoisted_24 = { class: "rounded-md w-[40px]" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "ltr:ml-[12px] rtl:mr-[12px]" }
const _hoisted_27 = { class: "block text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_28 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_29 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_30 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_31 = { class: "ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[15px] border-b border-gray-100 dark:border-[#172036] ltr:first:border-l ltr:last:border-r rtl:first:border-r rtl:last:border-l" }
const _hoisted_32 = { class: "flex items-center gap-[9px]" }
const _hoisted_33 = {
  type: "button",
  class: "text-danger-500 leading-none custom-tooltip"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("form", {
          class: "relative sm:w-[265px]",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchProducts && _ctx.fetchProducts(...args)), ["prevent"]))
        }, [
          _cache[3] || (_cache[3] = _createElementVNode("label", { class: "leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2" }, [
            _createElementVNode("i", { class: "material-symbols-outlined !text-[20px]" }, " search ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: _ctx.directT('ecommerce.productsList.searchHere'),
            class: "bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
            onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fetchProducts && _ctx.fetchProducts(...args)))
          }, null, 40, _hoisted_4), [
            [_vModelText, _ctx.searchQuery]
          ])
        ], 32)
      ]),
      (_ctx.canAddProducts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_RouterLink, {
              to: "/ecommerce/create-product",
              class: "inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white",
              id: "add-new-popup-toggle"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2" }, " add ", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('ecommerce.productsList.addNewProduct')), 1)
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[5] || (_cache[5] = [
            _createElementVNode("div", { class: "inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-primary-500 border-r-transparent" }, null, -1)
          ])))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
          : (_ctx.products.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.directT('ecommerce.productsList.noProductsFound')), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("table", _hoisted_12, [
                  _createElementVNode("thead", _hoisted_13, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.directT('ecommerce.productsList.id')), 1),
                      _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.directT('ecommerce.productsList.product')), 1),
                      _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.directT('ecommerce.productsList.category')), 1),
                      _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.directT('ecommerce.productsList.price')), 1),
                      _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.directT('ecommerce.productsList.amount')), 1),
                      _createElementVNode("th", _hoisted_19, _toDisplayString(_ctx.directT('ecommerce.productsList.actions')), 1)
                    ])
                  ]),
                  _createElementVNode("tbody", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: product.id
                      }, [
                        _createElementVNode("td", _hoisted_21, _toDisplayString(product.id.substring(0, 8)), 1),
                        _createElementVNode("td", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("img", {
                                src: product.image_link || require('@/assets/images/products/product1.jpg'),
                                class: "inline-block rounded-md",
                                alt: "product-image"
                              }, null, 8, _hoisted_25)
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_RouterLink, {
                                to: `/ecommerce/edit-product?id=${product.id}`,
                                class: "font-medium inline-block text-[14px] md:text-[15px] transition-all hover:text-primary-500 mb-px"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(product.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"]),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(product.published_at ? new Date(product.published_at).toLocaleDateString() : 'Draft'), 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(product.category || 'Uncategorized'), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(_ctx.formatPrice(product.price)), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(_ctx.formatPrice(product.compare_at_price)), 1),
                        _createElementVNode("td", _hoisted_31, [
                          _createElementVNode("div", _hoisted_32, [
                            _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                              to: `/ecommerce/edit-product?id=${product.id}`,
                              class: "text-primary-500 leading-none custom-tooltip"
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " edit ", -1)
                              ])),
                              _: 2
                            }, 1032, ["to"])), [
                              [_directive_tooltip, _ctx.directT('ecommerce.productsList.edit')]
                            ]),
                            _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_33, _cache[7] || (_cache[7] = [
                              _createElementVNode("i", { class: "material-symbols-outlined !text-md" }, " delete ", -1)
                            ]))), [
                              [_directive_tooltip, _ctx.directT('ecommerce.productsList.delete')]
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
    ])
  ]))
}